import { render } from "./hub.vue?vue&type=template&id=523e658e"
import script from "./hub.vue?vue&type=script&lang=js"
export * from "./hub.vue?vue&type=script&lang=js"

import "./hub.vue?vue&type=style&index=0&id=523e658e&lang=css"

import exportComponent from "C:\\Users\\CloudSecOffice\\Documents\\Gravitas\\microservice\\Frontend\\enterprise_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__